import interceptor from './interceptor';

//console.log(process.env.REACT_APP_NUPITCH_API_URL);
//use axios to  send a POST request to [HttpPost("confirm-email")] ConfirmEmail([FromBody] EmailConfirmVM emailConfirmVM)
//in nupitch-api/Controllers/AutheniticationController.cs
//with the emailConfirmVM containing the email and the token
//and then return the response
//the response should be a 200 OK if the token is valid
//and a 400 Bad Request if the token is invalid
//and a 500 Internal Server Error if there is an error
//the response should be a JSON object

const login = (email: string, password: string, rememberMe: boolean) => {
  const request = interceptor.apiWithAuth.post('/authentication/login-user', {
    email: email,
    password: password,
    rememberMe: rememberMe
  });

  return request.then(response => response.data);
};

const logout = (email: string, refreshToken: string) => {
  const request = interceptor.apiWithAuth.post('/authentication/logout-user', {
    email: email,
    refreshToken: refreshToken
  });

  return request.then(response => response.data);
};

const confirmEmail = (q_email: string, q_token: string) => {
  return interceptor.apiWithoutAuth
    .post('/authentication/confirm-email', {
      email: q_email,
      token: q_token
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error(error);
      return null;
    });
};

const resendConfirmationEmail = (q_email: string) => {
  return interceptor.apiWithoutAuth
    .post('/authentication/resend-confirmation-email', {
      email: q_email
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error(error);
      return null;
    });
};

const signUpNewUser = (
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  userName: string
) => {
  const request = interceptor.apiWithoutAuth.post(
    '/authentication/register-user',
    {
      firstName: firstName,
      lastName: lastName,
      email: email,
      userName: userName,
      password: password,
      role: 'member'
    }
  );

  return request.then(response => response.data);
};

const forgotPassword = (email: string) => {
  const request = interceptor.apiWithAuth.post(
    '/authentication/send-reset-password-link',
    JSON.stringify(email),
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  return request
    .then(response => response.data)
    .catch(error => {
      console.error('An error occurred:', error);
    });
};

const resetPassword = ({
  incomingEmail,
  password,
  confirmPassword,
  incomingToken
}: {
  incomingEmail: string;
  password: string;
  confirmPassword: string;
  incomingToken: string;
}) => {
  const request = interceptor.apiWithAuth.post(
    '/authentication/reset-password',
    {
      email: incomingEmail,
      newPassword: password,
      confirmPassword: confirmPassword,
      token: incomingToken
    }
  );

  return request
    .then(response => response.data)
    .catch(error => {
      // Return a rejected promise with the error message
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const authenticationService = {
  confirmEmail,
  resendConfirmationEmail,
  signUpNewUser,
  login,
  logout,
  forgotPassword,
  resetPassword
};
export default authenticationService;
